import { render, staticRenderFns } from "./permission-config-panel.vue?vue&type=template&id=8701d2be&scoped=true&"
import script from "./permission-config-panel.vue?vue&type=script&lang=js&"
export * from "./permission-config-panel.vue?vue&type=script&lang=js&"
import style0 from "./permission-config-panel.vue?vue&type=style&index=0&id=8701d2be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8701d2be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8701d2be')) {
      api.createRecord('8701d2be', component.options)
    } else {
      api.reload('8701d2be', component.options)
    }
    module.hot.accept("./permission-config-panel.vue?vue&type=template&id=8701d2be&scoped=true&", function () {
      api.rerender('8701d2be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/project/my/components/permission-config-panel.vue"
export default component.exports